import {
  defaultRequestInterceptor,
  defaultResponseInterceptor,
  errorMessageResponseInterceptor,
} from './core/preset-interceptors'
import { RequestClient } from './core/request-client'
import { ElMessage } from 'element-plus'

let baseURL = '/vue-api'
if (import.meta.env.DEV) {
  const urlParams = new URLSearchParams(window.location.search)
  const devProxy = urlParams.get('devProxy')
  baseURL = devProxy || '/sit-api'
}

const client = new RequestClient({
  baseURL,
  responseReturn: 'body',
  timeout: 50_000,
})

/**
 * 重新认证逻辑
 */
async function doReAuthenticate() {
  let loginUrl = '/pc-vue/login'
  if (import.meta.env.DEV) {
    loginUrl = `${location.pathname}${location.search}#/login`
  }

  if (window.parent) {
    window.parent.location.href = loginUrl
  } else {
    window.location.href = loginUrl
  }
}

// 请求头处理
client.addRequestInterceptor(defaultRequestInterceptor())

// 处理成功返回的响应数据格式
client.addResponseInterceptor(
  defaultResponseInterceptor({
    makeInfoMessage: (msg) => {
      ElMessage.error(msg)
    },
  }),
)

// 通用的错误处理,如果没有进入上面的错误处理逻辑，就会进入这里
client.addResponseInterceptor(
  errorMessageResponseInterceptor((msg: string, error) => {
    const responseData = error?.response?.data ?? {}
    const errorMessage = responseData?.error ?? responseData?.message ?? ''
    // 如果没有错误信息，则会根据状态码进行提示
    ElMessage.error({
      message: errorMessage || msg,
      onClose: () => {
        if (error?.response?.status === 401) {
          doReAuthenticate()
        }
      },
    })
  }),
)

export const http = client
export * from './core/types'
